import { EApplicantType, EFinancingProgram } from '@if/core/types'
import ActionsDialog from '@src/components/ActionsDialog'
import AsyncActionButton from '@src/components/AsyncActionButton'
import { useResendIdentityVerification } from '@src/data/api/credit-api/identity-verification-api'
import { Dispatch, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  creditApplicationId: string
  financingProgramId: EFinancingProgram
  applicantType: EApplicantType
  setError: Dispatch<Error>
}

const ResendIdentityVerificationButton = ({
  creditApplicationId,
  financingProgramId,
  applicantType,
  setError,
}: Props) => {
  const { t } = useTranslation()

  const [resendIdentityVerification, isPending, isError, isSuccess] = useResendIdentityVerification(
    creditApplicationId,
    financingProgramId,
    applicantType,
  )

  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const handleButtonClick = useCallback(() => {
    setIsDialogOpen(true)
  }, [])

  const handleConfirm = useCallback(async () => {
    setIsDialogOpen(false)
    try {
      await resendIdentityVerification()
    } catch (e) {
      setError(e as Error)
    }
  }, [resendIdentityVerification, setError])

  const handleCancel = useCallback(() => {
    setIsDialogOpen(false)
  }, [])

  return (
    <div>
      <AsyncActionButton
        isPending={isPending}
        isError={isError}
        isSuccess={isSuccess}
        onClick={handleButtonClick}
        fullWidth={false}
        variant="outlined"
      >
        {t('documentSectionHeaders.resendIdentityVerification')}
      </AsyncActionButton>
      <ActionsDialog
        open={isDialogOpen}
        title={t('documentSectionHeaders.resendIdentityVerificationConfirmTitle')}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      >
        {t('documentSectionHeaders.resendIdentityVerificationConfirmMessage')}
      </ActionsDialog>
    </div>
  )
}

export default ResendIdentityVerificationButton
